// components/FullscreenLoader.tsx
import React from 'react';
import loader from "../../../Assets/Dashboard/pdfloader.gif";
import styles from "./GlobalPDFLoader.module.scss";

const GlobalPDFLoader = () => {
    return (
        <div className={styles.overlay}>
            <img src={loader} alt="Loading..." className={styles.loaderImage} />
        </div>
    );
};

export default GlobalPDFLoader;
